import React from 'react';
import ServicesContext, { IServicesContext } from './ServicesContext';
import { ViewsService } from '../../context/view/ViewService';
import { SearchService } from '../../context/search/SearchService';
import { DocumentsService } from '../../context/documents/DocumentsService';
import { FieldsService } from '../../context/fields/FieldsService';
import { LocalesService } from '../../context/globalization/LocalesService';
import { CurrentUserService } from '../../context/currentUser/CurrentUserService';
import { UiAdminConfigsService } from '../../context/uiAdminConfigs/UiAdminConfigsService';
import { MsGraphService } from '../../context/msGraph/MsGraphService';
import { ContentTypesService } from '../../context/contentTypes/ContentTypesService';
import { ConfigurationService } from '../../context/configuration/ConfigurationService';
import { AssignmentsService } from '../../context/permissions/AssignmentsService';
import { TranslationsService } from '../../context/translations/TranslationsService';
import { IndexesService } from '../../context/indexes/IndexesService';
import { VersionsService } from '../../context/versions/VersionsService';

interface IServicesProviderProps {
  children: React.ReactNode;
}

const currentUserService = new CurrentUserService();
const viewsService = new ViewsService();
const fieldsService = new FieldsService();
const contentTypesService = new ContentTypesService();
const searchService = new SearchService();
const documentsService = new DocumentsService();
const localesService = new LocalesService();
const uiAdminConfigsService = new UiAdminConfigsService();
const msGraphService = new MsGraphService();
const configurationService = new ConfigurationService();
const assignmentsService = new AssignmentsService();
const translationsService = new TranslationsService();
const indexesService = new IndexesService();
const versionsService = new VersionsService();

const servicesContext: IServicesContext = {
  currentUserService,
  viewsService,
  fieldsService,
  contentTypesService,
  searchService,
  documentsService,
  localesService,
  uiAdminConfigsService,
  msGraphService,
  configurationService,
  assignmentsService,
  translationsService,
  indexesService,
  versionsService
};

const ServicesProvider: React.FC<IServicesProviderProps> = props => {
  return <ServicesContext.Provider value={servicesContext}>{props.children}</ServicesContext.Provider>;
};

export default ServicesProvider;
